import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Radio, { RadioProps } from '@/components/@IntranetLibrary/Radio';

export type RHFRadioProps = Pick<RadioProps, 'options'> & {
  readonly name: string;
};

function RHFRadio({ name, options }: RHFRadioProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => <Radio {...field} options={options} row />}
    />
  );
}

export default RHFRadio;
